import { Component, Input, OnInit, ViewChild } from "@angular/core";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Navigator } from "src/app/services/routing/navigator";
import { DepositMainLabels } from "src/app/interfaces/deposit-main-labels";
import { DepositMainModel } from "src/app/models/deposit-models";
import { CashierContentService } from "src/app/services/cashier/cashier-content.service";
import { CashierService } from "src/app/services/cashier/cashier.service";
import { DepositService } from "src/app/services/cashier/deposit.service";
import { isUndefined } from "src/app/services/codeUtils";
import { DEPOSIT_PATTERN } from "src/app/services/customFormValidators";
import { SuccessMessageService } from "src/app/services/message-provider/success-message.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { CashierBase } from "../../cashier-base/cashier-base";
import { first } from "rxjs/operators";
import { ConfigService } from "src/app/services/config/config.service";
import { IonContent, LoadingController, NavParams, Platform } from "@ionic/angular";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser/ngx";
import { AffiliateTrackerCallbackParams } from "src/app/interfaces/affliation-interface";
import { EventsService } from "src/app/services/event/event.service";

@Component({
  selector: "app-deposit-paypal",
  templateUrl: "./deposit-paypal.component.html",
  styleUrls: ["./deposit-paypal.component.scss"],
})

export class DepositPaypalComponent extends CashierBase implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;
  @Input() public navigateBackPage: any;

  public error = null;
  public labels: DepositMainLabels;
  public vendorLogoUrl: string = "";
  public minAmount: any;
  public defaultAmounts: any = [];
  public paymentType: any = [];
  public params: any;
  public bonusCode: string;
  public paymentRequestID: any;
  public customerId: any;
  public sessionToken: any;
  public amountSubmitted: any;
  public token: any;
  public PayerID: any;
  public accountsList: any;
  public paypalEmail: string;
  public buttonDisabled: boolean = false;
  public showPaypal: boolean = false;
  public newWindow: any;
  public depositForm: FormGroup;
  public amount: AbstractControl;
  public url;
  checkPaypalURL;
  checkPaypalHashValue;
  private loading;

  constructor(
    public cashierService: CashierService,
    public cashierContentService: CashierContentService,
    public configService: ConfigService,
    public depositService: DepositService,
    protected navParams: NavParams,
    public events: EventsService,
    public navigator: Navigator,
    public platform: Platform,
    public successMessageService: SuccessMessageService,
    public userSessionService: UserSessionService,
    public utilsService: UtilsService,
    public loadingController: LoadingController,
    private iab: InAppBrowser
  ) {
    super();
    this.url = navParams.get("params");
    this.checkPaypalURL = navParams.get("paypalResult");
    this.checkPaypalHashValue = navParams.get("paypalHashValue");
    this.successMessageService.clearMessage();
    this.labels = new DepositMainModel();
    this.error = null;

    this.checkSuccessfullPayment();
    //Display loading dialog while code fetches paypal result to make the redirect transition smooth
    if(this.checkPaypalURL){
      this.showLoading();
    }
  }

  ngOnInit() {
    this.depositForm = new FormGroup({
      amount: new FormControl("", {
        validators: [Validators.pattern(DEPOSIT_PATTERN), Validators.required],
        updateOn: "change",
      }),
    });

    this.amount = this.depositForm.get("amount");
    this.onGetAccounts();
    this.cashierContentService.bonusOfferValue.subscribe(
      (res) => (this.bonusCode = res)
    );
  }

  async showLoading() {
    this.loading = await this.loadingController.create({
      message: 'Please wait loading...',
      duration: 1500
    });
  
    this.loading.present();
  }

  ionViewDidEnter() {
    this.successMessageService.clearMessage();
    this.cashierService.getActivePaymentTypes("PPD").subscribe(
      (response: any) => {
        if (response && !!response.payload) {
          this.paymentType = response.payload[0];
          if (!!this.paymentType.min) this.minAmount = this.paymentType.min;
          this.defaultAmounts = this.cashierContentService.getDefaultPayments(
            response.payload,
            0
          );
        }
      },
      (error) => {
        this.error = this.handleError(error);
        this.content.scrollToTop(10);
      }
    );


    /* this.events.subscribe('event:deposit:approved', (data) => {
       console.log('paypal--',data)
       let depositEventData: AffiliateTrackerCallbackParams = {
         customer_id: this.cashierService.customer.customerId,
         amount: data.parametersMap.amount,
         paymentMethod: "PAYPAL"
       }
       setTimeout(() => this.events.publish('event:deposit', depositEventData), 2000);
     });*/

  }

  ngAfterViewInit() {
    this.cashierContentService
      .getPageConfig("paypal")
      .then((response: DepositMainLabels) => {
        this.labels = response;
      });
  }

  public onAmountSelected(data) {
    return this.depositForm.get("amount").setValue(data);
  }

  public checkSuccessfullPayment() {
    if (this.loading) {
      this.loading.dismiss();
    }
    //this.params = this.utilsService.getUrlParams();
    this.params = this.utilsService.getUrlParams(this.checkPaypalURL);
    //console.log('this.params----', this.params)
    if (this.params) {
      this.paymentRequestID = this.params.paymentrequestid;
      if (!!this.paymentRequestID) {
        this.showPaypal = false;
        this.customerId = this.params.customerid;
        this.sessionToken = this.params.session_token;
        this.amountSubmitted = this.params.amount;
        //this.token = this.getHashValue("token");
        //this.PayerID = this.getHashValue("PayerID");
        let hashExtractor = this.checkPaypalHashValue.split('#')[1].split('?')[0];
        //console.log('hashExtractor---', this.checkPaypalHashValue)
        this.token = hashExtractor.match(new RegExp('token' + "=([^&]*)")) ? hashExtractor.match(new RegExp('token' + "=([^&]*)"))[1] : null;
        this.PayerID = hashExtractor.match(new RegExp('PayerID' + "=([^&]*)")) ? hashExtractor.match(new RegExp('PayerID' + "=([^&]*)"))[1] : null;
        //console.log('this.token---', this.token);
        //console.log('this.payerID----', this.PayerID)
        //let hash = document.location.hash;
        if (~this.checkPaypalHashValue.indexOf("#paypal-nonfunded")) {
          return this.navigator.navigateTo(
            "DepositSuccessFailureComponent",
            {},
            {
              status: false,
              flag: "paypal",
              message: "Your deposit transaction did not succeed.",
            }
          );
        }
        return this.callPaypalConfirm(this.paymentRequestID);
      }
    }
  }

  public getHashValue(key) {
    let matches = location.hash.match(new RegExp(key + "=([^&]*)"));
    return matches ? matches[1] : null;
  }

  callPaypalConfirm(paymentRequestId) {
    let obj = {
      customer_id: this.customerId,
      session_token: this.sessionToken,
      token: this.token,
      payment_request_id: paymentRequestId,
      PayerID: this.PayerID,
    };

    return this.depositService
      .callPaypalConfirm(obj)
      .subscribe((response: any) => {
        this.checkDeposit(paymentRequestId);
      });
  }

  public checkDeposit(paymentRequestId: any) {
    if (!isUndefined(paymentRequestId)) {
      this.depositService
        .checkDepositStatus(paymentRequestId)
        .pipe(first())
        .subscribe(
          (response) => {
            if (!isUndefined(response.payload)) {
              switch (response.payload.status) {
                case "APPROVED":
                  let depositLimitExceeded = false;

                  if ("hasExceededDepositLimit" in response.payload) {
                    depositLimitExceeded =
                      response.payload.hasExceededDepositLimit;
                  }

                  if (depositLimitExceeded) {
                    this.navigator.navigateTo(
                      "DepositThresholdComponent",
                      {},
                      {
                        status: true,
                        amount: this.amountSubmitted,
                        customerId: this.cashierService.customer.customerId,
                      }
                    );
                    break;
                  }

                  this.navigator.navigateTo(
                    "DepositSuccessFailureComponent",
                    {},
                    { status: true, flag: "paypal" }
                  );

                  /*let depositEventData: AffiliateTrackerCallbackParams = {
                    customer_id: this.customerId,
                    amount: this.amountSubmitted,
                    paymentMethod: "PAYPALL",
                    sessionToken: this.sessionToken,
                    transaction_id: paymentRequestId,
                  };
                  setTimeout(
                    () =>
                      this.events.publish("event:deposit", depositEventData),
                    2000
                  );*/
                  break;
                case "IN PROCESS":
                  this.navigator.navigateTo(
                    "DepositSuccessFailureComponent",
                    {},
                    {
                      status: true,
                      navigateBackPage: "DepositPaypalComponent",
                      flag: "paypal",
                      message:
                        "Your deposit transaction is still in progress.<br/>Please check your account or contact customer support.",
                    }
                  );
                  break;
                case "CANCELLED":
                  this.navigator.navigateTo(
                    "DepositSuccessFailureComponent",
                    {},
                    {
                      status: false,
                      navigateBackPage: "DepositPaypalComponent",
                      flag: "paypal",
                      message: "Your deposit transaction did not succeed.",
                    }
                  );
                  break;
                default:
                  this.navigator.navigateTo(
                    "DepositSuccessFailureComponent",
                    {},
                    {
                      status: false,
                      navigateBackPage: "DepositPaypalComponent",
                      flag: "paypal",
                      message:
                        "Your deposit transaction could not be processed.",
                    }
                  );
                  break;
              }
              return;
            }
            return this.navigator.navigateTo(
              "DepositSuccessFailureComponent",
              {},
              {
                status: false,
                flag: "paypal",
                navigateBackPage: "DepositPaypalComponent",
              }
            );
          },
          (error) => {
            return this.navigator.navigateTo(
              "DepositSuccessFailureComponent",
              {},
              {
                status: false,
                flag: "paypal",
                navigateBackPage: "DepositPaypalComponent",
              }
            );
          }
        );
    }
  }

  public onGetAccounts() {
    if (this.accountsList != null) return (this.showPaypal = true);

    return new Promise((resolve: any, reject: any) => {
      this.cashierService.callListAccounts().subscribe(
        (response: any) => {
          if (response && !!response.result) {
            this.showPaypal = true;
            this.accountsList = response.payload;
            let paypalAccounts = this.accountsList.filter(
              (account) => account.paymentTypeCode == "PPD"
            );
            if (!!paypalAccounts.length)
              this.paypalEmail = paypalAccounts[0].accountAdditionalInfo4;
            resolve;
          }
        },
        (error) => {
          this.content.scrollToTop(10);
          this.showPaypal = true;
          this.error = this.handleError(error);
          reject();
          throw new Error(
            "Calling list-accounts webservice returns error: " + error
          );
        }
      );
    });
  }

  onSubmit() {
    this.buttonDisabled = true;
    this.successMessageService.clearMessage();
    this.error = null;

    let paypalData: any = {};
    paypalData.amount = this.depositForm.get("amount").value;
    paypalData.bonusCode = this.bonusCode;
    paypalData.currency_code = this.configService.getConfig().DEFAULT_CURRENCY;
    paypalData.payment_type_code = "PPD";

    this.cashierService.callDeposit(paypalData).subscribe(
      (response: any) => {
        if (response && !!response.result) {
          if (!this.isMobileApp()) {
            let w: any = window;
            this.newWindow = w.open("about:blank", "_system");
            this.newWindow.document.write(
              "<style> body{ background:var(--ion-color-secondary);!important;  position: relative;} div.container { margin: 0;position: absolute;top: 50%;left: 50%;-ms-transform: translate(-50%, -50%); transform: translate(-50%, -50%);color: white;font-family: roboto;font-size: 1.5em; }</style>"
            );
            this.newWindow.document.write(
              "<body><div class='container'>LOADING...</div></body>"
            );
          }

          let paymentRequestID = response.payload.paymentRequestID;
          let customerId = this.cashierService.customer.customerId;
          let sessionToken = this.userSessionService.getSessionToken();
          let confirmURL = `${this.configService.getConfig().LOBBY_URL
            }/cashierpaypal?paymentRequestID=${paymentRequestID}&amount=${this.depositForm.get("amount").value
            }&customerid=${customerId}&session_token=${sessionToken}#paypal-funded`;
          let cancelURL = `${this.configService.getConfig().LOBBY_URL
            }/cashierpaypal?paymentRequestID=${paymentRequestID}&amount=${this.depositForm.get("amount").value
            }&customerid=${customerId}&session_token=${sessionToken}#paypal-nonfunded`;
          let currency = this.configService.getConfig().DEFAULT_CURRENCY;

          this.navigator.dismissAll();
          this.depositService
            .getPaypalToken(
              this.depositForm.get("amount").value,
              currency,
              confirmURL,
              cancelURL
            )
            .pipe(first())
            .subscribe((response) => {
              if (!isUndefined(response) && !!response.result) {
                let payload = response.payload;

                if (
                  !isUndefined(payload["ACK"]) &&
                  payload["ACK"] === "Success"
                ) {
                  let paypalBaseUrl =
                    this.configService.getConfig().FEATURE_PAYPAL_URL;
                  let token = payload["TOKEN"];
                  let paypalUrl = `${paypalBaseUrl}?cmd=_express-checkout&token=${token}`;
                  if (this.isMobileApp()) {
                    this.newWindow = this.iab.create(
                      paypalUrl,
                      "",
                      "location=no,footer=no,hardwareback=no,hidenavigationbuttons=yes,closebuttoncaption=< back"
                    );
                    setTimeout(() => {
                      let interval = setInterval(() => {
                        this.newWindow.executeScript(
                          { code: "window._window_has_closed" },
                          (val) => {
                            if (val[0]) {
                              this.newWindow.close();
                              clearInterval(interval);
                            }
                          }
                        );
                      }, 500);
                    }, 3000);

                    this.newWindow.on("exit").subscribe((event) => {
                      this.depositService
                        .checkDepositStatus(paymentRequestID)
                        .pipe(first())
                        .subscribe((response) => {
                          if (!isUndefined(response.payload)) {
                            switch (response.payload.status) {
                              case "APPROVED":
                                let customerId =
                                  this.cashierService.customer.customerId;
                                let sessionToken =
                                  this.userSessionService.getSessionToken();

                                /*let depositEventData: AffiliateTrackerCallbackParams =
                                  {
                                    customer_id: customerId,
                                    amount: paypalData.amount,
                                    paymentMethod: "PAYPALL",
                                    sessionToken: sessionToken,
                                    transaction_id: paymentRequestID,
                                  };
                                setTimeout(
                                  () =>
                                    this.events.publish(
                                      "event:deposit",
                                      depositEventData
                                    ),
                                  2000
                                );*/
                                break;
                            }
                          }
                        });
                    });
                    this.buttonDisabled = false;
                  }
                  this.newWindow.location = paypalUrl;
                  this.buttonDisabled = false;
                  return this.newWindow.focus();
                }
                return console.error("ERROR No Paypal Token");
              }
            });
        }
      },
      (error) => {
        this.content.scrollToTop(10);
        this.buttonDisabled = false;
        this.error = this.handleError(error);
      }
    );
  }

  isMobileApp() {
    return this.platform.is("capacitor");
  }

  public selectedDepositBonusOffer($event): void {
    this.bonusCode = $event.selectedbonusOffer.campaign_code;
  }

  onBack = () => {
    this.cashierContentService.onBackHandler(this.navigateBackPage);
  };
}
